module.exports = __webpack_public_path__ + "static/img/kh.ab9b110d.png";